import Checkbox from '@material-ui/core/Checkbox';
import { checkResourceEntitlements } from './utils/utils';
import withGS from './withGShoc';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import { Component, default as React } from 'react';
import { withRouter } from 'react-router-dom';
import { globalStyles } from './style/gstheme';

const loadOptions = {
  predicates: [
    "http://purl.org/dc/terms/title",
    "http://purl.org/dc/terms/description",
    "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
  ]
};

const styles = theme => {
  return Object.assign({
    componentIcon: {
      backgroundColor: '#01579b',
      height: 29,
      verticalAlign: 'middle',
      width: 29
    },
    checked: {
      padding: 6
    },
    componentTitle: {
      fontSize: '16px',
      fontWeight: 500,
      marginTop: '2px',
      wordBreak: 'break-word',
      color: theme.palette.text.primary
    },
    componentDescription: {
      color: theme.palette.text.primary
    },
    componentItem: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: '15px',
      minHeight: '33px',
      paddingLeft: '15px',
      paddingBottom: '10px',
      borderTop: 'solid 1px ' + theme.palette.grey[300],
      paddingRight: '5px',
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: theme.palette.background.medium,
        borderTop: 'solid 1px ' + theme.palette.background.medium,
        borderRadius: '4px',
      },
      '&:last-child': {
        borderBottom: 'solid 1px ' + theme.palette.grey[300]
      }
    },
    deleteComponent: {
      width: '40px',
      textAlign: 'right'
    }
  }, globalStyles);
};

class ComponentListItem extends Component {

  state = {
    active: null,
  };

  onActivate = () => this.setState({ active: true });

  onDeactivate = () => this.setState({ active: false });

  viewComponent = () => this.props.history.push(this.props.link);

  render() {

    const { active } = this.state;
    const { id, classes, data, defaultLang, avatar, onDelete, additionalDisplay, changes,
      entitlement, dataTest, sync, selected, onSelect, filter } = this.props;
    const { title, description } = data;
    const componentTitle = title ?
      title[defaultLang] ?
        title[defaultLang]
        :
        title["und"] ?
          title["und"]
          :
          id
      :
      data.id;

    if (filter !== "" && !componentTitle.toLowerCase().includes(filter.toLowerCase())) return null;
    const descriptions = description && description[defaultLang] ?
      (
        Array.isArray(description[defaultLang]) ?
          description[defaultLang]
          :
          [description[defaultLang]]
      )
      : null;

    const isReadOnly = this.props.isReadOnly || checkResourceEntitlements(data, [entitlement]);

    return (
      <div data-test={dataTest} className={classes.componentItem}
        onClick={sync ? null : this.viewComponent}
        onMouseEnter={this.onActivate}
        onMouseLeave={this.onDeactivate}>
        <div style={{ float: 'left', width: 'calc(100% - 40px)', display: 'flex' }}>
          <div style={{ paddingRight: '10px' }}>
            <Avatar className={classes.componentIcon}>{avatar}</Avatar>
          </div>
          <div>
            <Typography data-test="component-title" className={classes.componentTitle}>
              {componentTitle}
            </Typography>
            {changes &&
              <Typography
                data-test="changes"
                style={{ color: '#ff6600' }}
                variant="body2"
                className={classes.componentDescription}>{changes.resourceCount} resource(s) changed since last run.</Typography>
            }
            {descriptions && descriptions.map((item, index) =>
              <Typography key={index} variant="body2" className={classes.componentDescription}>{item}</Typography>
            )}
            {additionalDisplay}
          </div>
        </div>
        <div data-test={sync && selected ? 'sync-selected' : 'not-selected'} className={classes.deleteComponent}>
          {!isReadOnly && onDelete && active && !sync &&
            <Tooltip data-test="delete-component" title="Delete component">
              <IconButton size="small" onClick={onDelete}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          }
          {sync &&
            <Tooltip data-test="sync-component" title="Select for synchronisation">
              <Checkbox size="small" color="primary" className={classes.checked} checked={selected} onClick={(ev) => onSelect(ev, id)} />
            </Tooltip>
          }
        </div>
      </div>
    );
  }
}

ComponentListItem.defaultProps = {
  filter: ""
};

ComponentListItem.propTypes = {
  dataTest: PropTypes.string,
  history: PropTypes.any,
  changes: PropTypes.object,
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  graph: PropTypes.string.isRequired,
  filter: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.object,
  entitlement: PropTypes.string,
  sync: PropTypes.bool,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  accessEntitlements: PropTypes.array,
  link: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool,
  additionalDisplay: PropTypes.object,
  defaultLang: PropTypes.string.isRequired,
  avatar: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  description: PropTypes.object
};

export default withRouter(withStyles(styles)(withGS(ComponentListItem, ["ALL"], ["id", "title", "description", "hasEntitlement"], loadOptions)));